import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogViewFoundId = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({
      name: 'VIEW_FOUND_ID',
      channel: ['firebase', 'amplitude', 'ablylog'],
      analytics: {
        SCREEN: 'FOUND_ID',
      },
    });
  }, [logAnalyticsEvent]);
};
